<template>
  <b-form-group
    class="estage-form-element-group mb-0"
  >
    <template
      v-if="control.label"
      slot="label"
    >
      <div
        v-html="label"
      />
    </template>

    <legend class="d-none active" />

    <b-input
      v-model="control.value"
      :placeholder="control.placeholder"
      :required="!!control.is_required"
      v-bind="$attrs"
      class="input"
      @focus="focus"
      @blur="blur"
    />
  </b-form-group>
</template>

<script>
import FormControlMixin from './FormControlMixin'
import BorderMixin from '@/components/mixins/BorderMixin'

export default {
  name: 'FormInput',
  mixins: [FormControlMixin, BorderMixin]
}
</script>

<style>
fieldset legend {
  transition: 150ms;
}
</style>